module.exports = new __parcel__URL__("tailwind.d5ce96e0.svg").toString();